import { createSlice } from "@reduxjs/toolkit";
import { getStudentExam } from "../../builders/studentExam/studentExam.builder";
const initialState = {
    loading: false,
    studentResultData: [],
};

const studentExamSlice = createSlice({
    name: "studentExam",
    initialState,
    reducers: {
       
        clearExtraReducers  : (state) =>{
           state.loading = false,
           state.studentResultData = []
          },
      },
    extraReducers: (builder) => {
    
        builder.addCase(getStudentExam.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getStudentExam.fulfilled, (state, action) => {
            state.loading = false
            state.studentResultData = action.payload

        });
        builder.addCase(getStudentExam.rejected, (state) => {
            state.loading = false
        });
    
    },
});


export default studentExamSlice.reducer;
